<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    bottom
    :mini-variant.sync="mini"
    permanent
    expand-on-hover
    class="nnn"
  >
    <!-- expand-on-hover -->
    <!-- TODO ส่วนสำหรับแสดง Title -->
    <v-list-item class="px-2 py-10" style="max-height: 48px">
      <!-- TODO ส่วนสำหรับแสดง Logo -->
      <v-list-item-avatar>
        <v-img src="@/assets/images/logo1.png"></v-img>
      </v-list-item-avatar>

      <!-- TODO ส่วนสำหรับแสดงข้อความ -->
      <v-list-item-content class="pb-0">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
          "
        >
          <span style="font-size: 40px; color: #000; font-weight: 500">
            LIFE
          </span>
          <span style="font-size: 30px; font-weight: 300">SYSTEM</span>
        </div>
      </v-list-item-content>
    </v-list-item>

    <!-- <v-divider></v-divider> -->
    <div class="xxx">
      <v-list class="navigation" nav dense>
        <router-link
          v-for="item in menus"
          :key="item.text"
          custom
          :to="item.to"
          v-slot="{ isActive, isExactActive }"
          :id="`menu-name-${item.text}`"
        >
          <!-- TODO เมื่อไม่มี Sub items -->
          <v-list-item
            v-if="item.items.length == 0"
            :to="item.to"
            @click="$emit('clickMenu', item)"
            :class="[
              isActive && 'active',
              isExactActive && 'router-link-exact-active',
            ]"
            active-class="active-item"
          >
            <v-list-item-icon>
              <v-icon color="primary">
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="menu-text">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>

          <!-- TODO เมื่อมี sub items -->
          <v-list-group
            v-else
            :value="false"
            no-action
            color="primary"
            :prepend-icon="item.icon"
            :class="[
              isActive && 'active-no-action',
              isExactActive && 'router-link-exact-active-no-action',
            ]"
          >
            <template v-slot:activator>
              <v-list-item-content
                :class="[
                  isActive && 'active-no-action',
                  isExactActive && 'router-link-exact-active-no-action',
                ]"
              >
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <router-link
              v-for="item in item.items"
              :key="item.text"
              custom
              :to="item.to"
              v-slot="{ isActive, isExactActive }"
              :id="`menu-name-${item.text}`"
            >
              <v-list-item
                style="padding-left: 42px"
                :to="item.to"
                @click="$emit('clickMenu', item)"
                :class="[
                  isActive && 'active',
                  isExactActive && 'router-link-exact-active',
                ]"
                active-class="active-item"
              >
                <v-list-item-icon>
                  <v-icon color="primary">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </router-link>
          </v-list-group>
        </router-link>
      </v-list>

      <v-divider v-if="options.length"></v-divider>

      <v-list class="options" dense nav>
        <v-list-item
          v-for="item in options"
          :key="item.menu_id"
          @click="$emit('clickOption', item)"
          :class="[currentOption === item.text ? 'active' : '']"
        >
          <v-list-item-icon>
            <v-icon color="primary">
              {{ item.icon || localIcon(item.text) }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-text">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
    <template v-slot:append>
      <div class="version-text">
        <span>Copyright &#174;&nbsp; </span>
        {{ new Date().getFullYear() }}
        <span>&nbsp;ManageAI</span><span>&nbsp;{{ version }}</span>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array,
      default: () => []
    },
    version: {
      type: String,
      default: process.env.VUE_APP_VERSION
    },
    options: {
      type: Array,
      default: () => []
    },
    currentOption: {
      type: String,
      default: ''
    }
  },
  computed: {
    drawer: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  methods: {
    toggle () {
      console.log('click')
    },
    localIcon (name) {
      switch (name) {
        case 'บัญชีผู้ใช้':
          return 'mdi-account-group-outline'
        case 'API':
          return 'mdi-api'
        case 'แพ็คเกจ':
          return 'mdi-database'
        case 'รออนุมัติ':
          return 'mdi-account-alert-outline'
        case 'ภาพรวม':
          return 'mdi-view-dashboard-outline'
        case 'ประวัติ':
          return 'mdi-format-list-bulleted'
        case 'อัปโหลด':
          return 'mdi-file-upload-outline'
        default:
          return 'mdi-pen'
      }
    }
  },
  data () {
    return {
      mini: true
    }
  }
}
</script>

<style lang="css" scoped>
::v-deep .active {
  /* border-right-style: solid; */
  /* border-right-color: var(--v-primary-base); */
  background-color: var(--v-primary-base) !important;
  color: #fff !important;
  /* background: linear-gradient(
    90deg,
    var(--v-gradient3-base) 0%,
    var(--v-gradient4-base) 100%
  ); */
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 20px;
}

::v-deep .xxx {
  height: calc(100% - 100px) !important;
  overflow: scroll;
}

.navigation .menu-text,
.navigation .v-list-item__title,
.options .v-list-item__title {
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 20px;
}

/* .theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0 !important;
} */

/* >>> .navigation .active-no-action {
  color: var(--v-primary-base) !important;
} */

/* ::v-deep .active-no-action .v-list-group__header .v-icon {
  color: var(--v-primary-base) !important;
} */
/* ::v-deep .v-list-group .v-icon  {
  color: var(--v-primary-base) !important;
} */

::v-deep .v-list-item__content,
::v-deep .v-list-item__title {
  color: var(--v-primary-base) !important;
}
::v-deep .v-list-group.v-list-group--active .v-icon,
::v-deep .v-list-group .v-list-item .v-icon,
::v-deep .v-list-group .v-list-item .v-list-item__content {
  color: var(--v-primary-base) !important;
}

.v-list-item.v-list-item--active.v-list-item--link .menu-text,
.v-list-group .v-list-group__items .v-list-item--active .v-list-item__title,
.v-list-item.v-list-item--active.v-list-item--link .v-icon {
  color: #fff !important;
}

/* ::v-deep .v-list-group--active .v-icon {
  color: var(--v-primary-base);
}
::v-deep .active-no-action .v-list-item .v-icon,
.active-no-action .v-icon {
  color: var(--v-primary-base);
} */

.version-text {
  display: flex;
  font-size: 11px;
  font-weight: 300;
  justify-content: center;
  align-content: center;
  /* word-wrap: break-word; */
  /* -webkit-flex-direction: column; */
  /* flex-direction: column; */
  transition: all 1s ease;
  opacity: 1;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.v-navigation-drawer--mini-variant .version-text {
  transition: all 0.2s;
  opacity: 0;
}

.v-list.options .v-list-item.active .v-icon,
.v-list.options .v-list-item.active .v-list-item__title {
  color: #fff !important;
}
</style>
